import React, {useState} from "react";
import "./DesignerPageHeaderControls.css";

const DesignerPageHeaderControls = ({
                                        pages,
                                        selectedPageId,
                                        setSelectedPageId,
                                        selectedPage,
                                        newPageTitle,
                                        setNewPageTitle,
                                        creatingPage,
                                        onCreatePage,
                                        onDuplicatePage,
                                        saving,
                                        hasUnsavedChanges,
                                        onSaveChanges,
                                        onResetChanges,
                                        onUpdatePageSettings,
                                    }) => {
    const [collapsed, setCollapsed] = useState(false);

    if (collapsed) {
        return (
            <button
                type="button"
                className="dph-collapsed-btn"
                onClick={() => setCollapsed(false)}
            >
                Page Controls
            </button>
        );
    }

    return (
        <div className="dph-panel">
            <div className="dph-header">
                <h3 className="dph-title">Page Controls</h3>

                <button
                    type="button"
                    className="dph-collapse-btn"
                    onClick={() => setCollapsed(true)}
                >
                    −
                </button>
            </div>

            <div className="dph-field">
                <label>Select Page</label>
                <select
                    value={selectedPageId}
                    onChange={(e) => setSelectedPageId(e.target.value)}
                >
                    <option value="">Select a page</option>
                    {(pages || []).map((page) => (
                        <option key={page.id} value={page.id}>
                            {page.title}
                            {page.is_published ? " - Published" : ""}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dph-field">
                <label>New Page</label>
                <input
                    type="text"
                    value={newPageTitle}
                    onChange={(e) => setNewPageTitle(e.target.value)}
                    placeholder="New page title"
                    onKeyDown={(e) => {
                        if (e.key === "Enter") onCreatePage();
                    }}
                />
            </div>

            <button
                type="button"
                className="dph-btn dph-btn--green"
                disabled={creatingPage || !newPageTitle.trim()}
                onClick={onCreatePage}
            >
                {creatingPage ? "Adding..." : "Add Page"}
            </button>
            <button
                type="button"
                className="dph-btn"
                disabled={!selectedPage}
                onClick={onDuplicatePage}
            >
                Duplicate Page
            </button>
            {selectedPage && (
                <div className="dph-settings">
                    <h4>Page Settings</h4>

                    <div className="dph-grid-2">
                        <div className="dph-field">
                            <label>Width</label>
                            <input
                                type="number"
                                value={selectedPage.width || 1600}
                                onChange={(e) =>
                                    onUpdatePageSettings({
                                        width: Math.max(100, Number(e.target.value) || 1600),
                                    })
                                }
                            />
                        </div>

                        <div className="dph-field">
                            <label>Height</label>
                            <input
                                type="number"
                                value={selectedPage.height || 900}
                                onChange={(e) =>
                                    onUpdatePageSettings({
                                        height: Math.max(100, Number(e.target.value) || 900),
                                    })
                                }
                            />
                        </div>
                    </div>

                    <div className="dph-field">
                        <label>Background Color</label>
                        <input
                            type="text"
                            value={selectedPage.background_color || "#ffffff"}
                            onChange={(e) =>
                                onUpdatePageSettings({
                                    background_color: e.target.value,
                                })
                            }
                        />
                    </div>

                    <div className="dph-grid-2">
                        <label className="dph-check">
                            <input
                                type="checkbox"
                                checked={selectedPage.show_grid !== false}
                                onChange={(e) =>
                                    onUpdatePageSettings({
                                        show_grid: e.target.checked,
                                    })
                                }
                            />
                            Show Grid
                        </label>

                        <label className="dph-check">
                            <input
                                type="checkbox"
                                checked={!!selectedPage.is_published}
                                onChange={(e) =>
                                    onUpdatePageSettings({
                                        is_published: e.target.checked,
                                    })
                                }
                            />
                            Published
                        </label>
                    </div>

                    <div className="dph-field">
                        <label>Grid Size</label>
                        <input
                            type="number"
                            value={selectedPage.grid_size || 20}
                            onChange={(e) =>
                                onUpdatePageSettings({
                                    grid_size: Math.max(5, Number(e.target.value) || 20),
                                })
                            }
                        />
                    </div>
                </div>
            )}

            <div className="dph-actions">
                <button
                    type="button"
                    className="dph-btn dph-btn--blue"
                    disabled={saving || !hasUnsavedChanges}
                    onClick={onSaveChanges}
                >
                    {saving ? "Saving..." : "Save Changes"}
                </button>

                <button
                    type="button"
                    className="dph-btn"
                    disabled={!hasUnsavedChanges}
                    onClick={onResetChanges}
                >
                    Reset
                </button>
            </div>
        </div>
    );
};

export default DesignerPageHeaderControls;